var path = '/app/pages/admin/home/admin.home.html';
var html = "<div class=\"container py-5\"> <div class=row> <div class=\"col-md col-sm-12 mb-2\" ng-repeat=\"widget in ctrl.widgets\"> <account-widget icon=widget.icon line-one=widget.data line-two=widget.label gradient=widget.gradient> </account-widget> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/home/admin.home.html
// module id = 584
// module chunks = 0